import DOMPurify from 'dompurify';

// Whitelist of inline CSS properties allowed in style="..." attributes.
// DOMPurify won't strip <span style="color: red; font-size: 22px"> because of
// these — anything outside the list is removed by DOMPurify's CSS sanitizer.
const ALLOWED_TAGS = [
  'b', 'i', 'em', 'strong', 'u', 's', 'strike', 'sup', 'sub',
  'a', 'p', 'br', 'hr',
  'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'blockquote', 'pre', 'code',
  'span', 'div',
  'img',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
];

const ALLOWED_ATTR = [
  'href', 'target', 'rel',
  'src', 'alt',
  'class', 'style',
];

// Convert text-level newlines to <br/> but preserve block element boundaries
// (h1-h6, ul, ol, li, blockquote, etc. already provide their own line break).
function smartNewlinesToBr(raw) {
  if (!raw) return raw;
  // If the input already looks like HTML (contains tags), don't touch newlines
  // — execCommand outputs proper <div>/<br> already.
  if (/<\w+[^>]*>/.test(raw)) return raw;
  let html = raw.replace(/\n\n+/g, '<br/><br/>');
  html = html.replace(/\n/g, '<br/>');
  return html;
}

export function sanitizeHTML(raw) {
  if (!raw) return '';
  const html = smartNewlinesToBr(raw);
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
  });
}

/**
 * Strip every HTML tag and decode entities, returning a single-line plain
 * string. Used in card-style listings where formatting must be ignored
 * (truncation via slice / line-clamp).
 */
export function stripHTML(raw) {
  if (!raw) return '';
  // Quick path — no tags means nothing to strip.
  if (!/[<&]/.test(raw)) return raw.replace(/\s+/g, ' ').trim();
  const sanitized = DOMPurify.sanitize(raw, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  // DOMPurify already decoded entities, but it leaves whitespace from block
  // tags. Collapse it so list cards look tidy.
  return sanitized.replace(/\s+/g, ' ').trim();
}
